import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  performLogin as performLoginAction,
  setLoginMode,
  setPassword,
  setUsername,
  submitMagicLink,
} from '../../../Actions/Login.action';
import Input from '../../Input';
import { translate } from '../../../Services/translation';
import { LoginModes } from '../../../constants';
import HCaptcha from '@hcaptcha/react-hcaptcha';

const HCAPTCHA_SITE_KEY = window.__litium.recaptchaSitekey;

const LoginForm = () => {
  const { isLoading, username = '', password = '', registerUrl, magicLinkModel } = useSelector(
    (state) => state.login
  );
  const dispatch = useDispatch();
  const captchaRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleVerify = async (token) => {
    try {
      dispatch(performLoginAction(username, password, token));
    } catch (err) {
      captchaRef.current.resetCaptcha();
    }
  };

  const performLogin = async (e) => {
    if (e) e.preventDefault();
    captchaRef.current.execute();
  };

  useEffect(() => {
    if (!magicLinkModel?.link) return;
    dispatch(submitMagicLink(magicLinkModel));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <form className="login__form" onSubmit={performLogin}>
        <Input
          label={translate('login.label.username')}
          onChange={(e) => dispatch(setUsername(e.target.value))}
          required
          disabled={isLoading}
          type="text"
          id="username"
          autoComplete="username"
          value={username}
        />
        <Input
          label={translate('login.label.password')}
          onChange={(e) => dispatch(setPassword(e.target.value))}
          required
          disabled={isLoading}
          type={showPassword ? 'text' : 'password'}
          id="password"
          autoComplete="current-password"
          value={password}
          icon={showPassword ? 'Eye-Off' : 'Eye'}
          iconOnClick={() => setShowPassword((prev) => !prev)}
        />
        <HCaptcha
          sitekey={HCAPTCHA_SITE_KEY}
          ref={captchaRef}
          size="invisible"
          onVerify={handleVerify}
        />
        <button
          className="login__submit-button"
          type="submit"
          disabled={isLoading}
        >
          {translate(isLoading ? 'login.loading' : 'login.login')}
        </button>
      </form>
      <div className="login__additional-actions">
        {registerUrl && (
          <button
            className="login__register-button"
            disabled={isLoading}
            onClick={() => {
              window.location.href = registerUrl;
            }}
          >
            {translate('login.register')}
          </button>
        )}
        <button
          className="login__forgot-password-button"
          disabled={isLoading}
          onClick={() => dispatch(setLoginMode(LoginModes.ForgotPassword))}
        >
          {translate('login.forgot-password')}
        </button>
      </div>
    </>
  );
};

export default LoginForm;
